import React, { ReactElement } from 'react';

export default function Compliance(): ReactElement {
  return (
    <div className="header-bar">
      <h1>Compliance Dashboard</h1>
    </div>
  )
}
